import EyeSlash from './EyeSlash';

export default EyeSlash;
